define('services/platform.service',[], function() {
    /**
     * Platform Detection Service - Capacitor Migration
     * 
     * Provides a unified interface for platform detection using Capacitor Device plugin.
     * Replaces all window.cordova checks throughout the application.
     */
    
    var PlatformService = {
        _deviceInfo: null,
        _deviceInfoPromise: null,
        
        /**
         * Get device info (cached after first call)
         * @returns {Promise} Promise that resolves with device info
         */
        getDeviceInfo: function() {
            if (this._deviceInfo) {
                return Promise.resolve(this._deviceInfo);
            }
            
            if (this._deviceInfoPromise) {
                return this._deviceInfoPromise;
            }
            
            if (window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.Device) {
                this._deviceInfoPromise = window.Capacitor.Plugins.Device.getInfo().then(function(info) {
                    PlatformService._deviceInfo = info;
                    return info;
                }).catch(function(error) {
                    console.error('Failed to get device info:', error);
                    return { platform: 'web', isNative: false };
                });
                return this._deviceInfoPromise;
            }
            
            // Fallback for web
            this._deviceInfo = { platform: 'web', isNative: false };
            return Promise.resolve(this._deviceInfo);
        },
        
        /**
         * Check if running on native platform (iOS/Android)
         * Replaces: Boolean(window.cordova) or window.cordova checks
         * @returns {boolean}
         */
        isNative: function() {
            return window.Capacitor && window.Capacitor.isNativePlatform();
        },
        
        /**
         * Check if running on mobile platform (native or mobile web)
         * Replaces: Boolean(window.cordova) for isMobile checks
         * @returns {boolean}
         */
        isMobile: function() {
            return this.isNative();
        },
        
        /**
         * Get platform name (ios, android, web)
         * @returns {Promise<string>}
         */
        getPlatform: function() {
            return this.getDeviceInfo().then(function(info) {
                return info.platform || 'web';
            });
        },
        
        /**
         * Check if running on iOS
         * @returns {Promise<boolean>}
         */
        isIOS: function() {
            return this.getDeviceInfo().then(function(info) {
                return info.platform === 'ios';
            });
        },
        
        /**
         * Check if running on Android
         * @returns {Promise<boolean>}
         */
        isAndroid: function() {
            return this.getDeviceInfo().then(function(info) {
                return info.platform === 'android';
            });
        },
        
        /**
         * Check if running on web (browser)
         * @returns {boolean}
         */
        isWeb: function() {
            return !this.isNative();
        }
    };
    
    return PlatformService;
});


